<template>
  <div class="housingInfo" v-loading="loading">
    <div class="index-header">
      <span class="title"> <i class="el-icon-caret-right"></i>小区信息 </span>
      <span class="other more"></span>
    </div>
    <div class="housingInfo-main" v-if="dataTable.length > 0">
      <template v-for="(item, index) in dataTable">
        <div :key="index" class="housingInfo-main-rel">
          <div class="housingInfo-main-head">
            <div class="title">
              <span @click="enterArea(item.EaAreaCode)">
                {{ item.EaAreaName }}
              </span>
              <span
                class="danger-icon"
                @click.prevent="showDanderInfo(item)"
                v-if="item.HiddendangerVo"
              >
                <img src="./img/danger.png" />
              </span>
            </div>
            <span
              class="titleTip"
              style="cursor: pointer"
              @click="enterKeydangerledger(item.EaAreaCode)"
              >【重点危险源台账】</span
            >
          </div>
          <div class="housingInfo-main-body">
            <div class="lineText">
              <div class="fontSize" style="width: 25%">
                楼栋数:
                <span
                  class="fontBlueSize"
                  @click="enterHousManage(item.EaAreaCode, item.EaAreaName)"
                  >{{ item.EaBuildCount }}</span
                >栋
              </div>
              <div class="fontSize" style="width: 25%">
                房屋数：
                <span
                  class="fontBlueSize"
                  @click="enterHousManage(item.EaAreaCode, item.EaAreaName)"
                  >{{ item.EaHouseCount }}</span
                >个
              </div>
              <div class="fontSize" style="width: 50%">
                面积：
                <span
                  class="fontBlueSize"
                  @click="enterHousManage(item.EaAreaCode, item.EaAreaName)"
                  >{{ item.ProjectArea ? item.ProjectArea : '0.00' }}</span
                >㎡
              </div>
            </div>
            <div class="vertaline">
              <div></div>
            </div>
            <div class="lineText">
              <div class="fontSize">
                设备总数：
                <span
                  class="fontBlueSize"
                  @click="enterEquipment(item.EaAreaCode, item.EaAreaName)"
                  >{{ item.FacilityCount }}</span
                >个
              </div>
              <!-- <div class="fontSize">
                报修数：
                <span
                  class="fontBlueSize"
                  @click="enterRepair(item.EaAreaCode,item.EaAreaName)"
                >{{item.RepairCount}}</span>个
              </div>
              <div class="fontSize">
                巡检数：
                <span
                  class="fontBlueSize"
                  @click="enterPatrol(item.EaAreaCode,item.EaAreaName)"
                >{{item.CheckCount}}</span>次
              </div>
              <div class="fontSize">
                维保数：
                <span
                  class="fontBlueSize"
                  @click="entermaintenance(item.EaAreaCode,item.EaAreaName)"
                >{{item.MaintainCount}}</span>次
              </div>-->
            </div>
            <div class="vertaline">
              <div></div>
            </div>
            <div class="lineText">
              <!-- <div class="fontSize">
                投诉总数：
                <span
                  class="fontBlueSize"
                  @click="enterRecord(item.EaAreaCode,item.EaAreaName)"
                >{{item.ComplaintCount}}</span>件
              </div>-->
              <div class="fontSize">&nbsp;</div>
              <div class="fontSize">&nbsp;</div>
              <div class="fontSize">&nbsp;</div>
            </div>
            <div class="housingInfo-main-body-foot">
              <div>
                项目经理：{{ item.RealtyManage ? item.RealtyManage : '暂无' }}
                {{ item.RealtyManageCall }}
              </div>
              <div>
                业委会主任：{{ item.MasterName ? item.MasterName : '暂无' }}
                {{ item.MasterTel }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div :key="index" class="housingInfo-main-rel" v-if="!item.title"s>
          <div class="housingInfo-main-head"></div>
          <div class="housingInfo-main-body"></div>
        </div>-->
      </template>
    </div>
    <div class="tx-c mar-t" v-if="dataTable.length < 1">
      <svg-icon icon-class="NoWork" class="iconStyle"></svg-icon>
      <br />暂无数据
    </div>
    <div class="housingInfo-main-foot">
      <span class="mar-r" @click="showmore()" v-if="dataTable.length > 0">
        {{ loadingOver ? '暂无更多' : '加载更多' }}
        <i v-if="!loadingOver" id="moreico" class="el-icon-arrow-down"></i>
      </span>
      <span class="mar-l" @click="closemore()" v-if="dataTable.length > 2">
        收起
        <i id="moreico" class="el-icon-arrow-up"></i>
      </span>
    </div>
    <el-dialog
      title="安全隐患"
      :visible.sync="managerDangerDialog"
      width="30%"
      :close-on-click-modal="false"
      custom-class="manager-danger-dialog"
    >
      <div class="danger-info">
        <div class="area-name">
          项目{{ dangerInfo.HiddendangerVo?.EaAreaName }}有如下安全隐患问题：
        </div>
        <div
          class="item-info"
          v-for="(item, index) in dangerInfo.HiddendangerVo?.TypeVos"
          :key="item.SafeHdType"
        >
          {{ index + 1 }}、{{ item.SafeHdName }}
        </div>
        <div class="info-time">
          登记时间：
          {{
            dangerInfo.HiddendangerVo?.CreateTime | formatDate('yyyy年MM月dd日')
          }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import nationalRegion from '@/utils/nationalRegion';
import { mapState } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      nationalRegion: nationalRegion,
      dataTable: [],
      show: true,
      startIndex: 0,
      maxSize: 6,
      loading: false,
      loadingOver: false,
      managerDangerDialog: false,
      dangerInfo: {},
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    },
    ...mapState(['token']),
  },
  created() {
    this.homePageControllerSvr = new HomePageControllerSvr();
  },
  mounted() {
    this.getData();
  },
  methods: {
    showmore() {
      if (!this.loadingOver) {
        this.startIndex = this.startIndex + this.maxSize;
        this.getData();
      }
    },
    // 显示安全隐患信息
    showDanderInfo(item) {
      this.managerDangerDialog = true;
      this.dangerInfo = item;
    },
    closemore() {
      this.loadingOver = false;
      this.startIndex = 0;
      this.dataTable.length = 0;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.homePageControllerSvr
        .GetAreaInfo(this.token, this.startIndex, this.maxSize)
        .then((res) => {
          this.dataTable = this.dataTable.concat(res._Items);
          if (res._Items.length < this.maxSize) {
            this.loadingOver = true;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    enterHousManage(code, name) {
      this.$router.push({
        path: '/housManage',
        query: { EaAreaCode: code, EaAreaName: name },
      });
    },
    enterEquipment(code, name) {
      this.$router.push({
        path: '/equAdministration',
        query: { EaAreaCode: code, EaAreaName: name },
      });
    },
    enterRepair(code, name) {
      this.$router.push({
        path: '/repairMge',
        query: { EaAreaCode: code, EaAreaName: name },
      });
    },
    enterPatrol(code, name) {
      this.$router.push({
        path: '/patrolRecordList',
        query: { EaAreaCode: code, EaAreaName: name },
      });
    },
    entermaintenance(code, name) {
      this.$router.push({
        path: '/maintenanceMge',
        query: { EaAreaCode: code, EaAreaName: name },
      });
    },
    enterRecord(code, name) {
      this.$router.push({
        path: '/recordMge',
        query: { EaAreaCode: code, EaAreaName: name },
      });
    },
    enterArea(code) {
      this.$router.push({
        path: '/propertyAreaInfo',
        query: { EaAreaCode: code, t: Date.now() },
      });
    },
    enterKeydangerledger(code) {
      this.$router.push({
        path: '/equAdministrationAccount',
        query: { OrgCode: code },
      });
    },
  },
};
</script>
<style lang="scss">
@import './css/common.scss';
.housingInfo {
  background-color: #fff;
  .index-header {
    .more {
      color: blue;
    }
  }
  .iconStyle {
    font-size: 100px;
    padding-bottom: 20px;
  }
  .housingInfo-main {
    padding: 0 10px;
    overflow: hidden;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    background-color: #fff;
    .housingInfo-main-rel {
      min-width: 440px;
      // margin: 0 10px 0 10px;
      max-width: 740px;
      flex: 0 1 49%;
      .housingInfo-main-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          position: relative;
          .danger-icon {
            position: absolute;
            top: -4px;
            margin-left: 6px;
            display: inline-block;
            width: 20px;
            cursor: pointer;
            img {
              width: 100%;
            }
          }
        }
      }
      .housingInfo-main-body {
        height: 200px;
        background-color: #f2f2f2;
        border-radius: 4px;
        .lineText {
          display: flex;
          height: 54px;
          padding: 0 15px;
          align-items: center;
        }
        .housingInfo-main-body-foot {
          height: 35px;
          display: flex;
          align-items: center;
          background-color: #daeaff;
          border-radius: 0px;
          justify-content: space-around;
        }
      }
    }

    //长横线
    .vertaline {
      width: 100%;
      height: 1%;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      div {
        width: 95%;
        height: 1px;
        border: 1px dashed #e2e2e2;
      }
    }
    //数字样式
    .numFontSizeBlue {
      width: 27px;
      height: 18px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
    }
    //字体样式
    .fontSize {
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
      width: 25%;
    }
    //红色
    .fontRed {
      color: #ff4546;
    }
    //蓝色
    .fontBlueSize {
      height: 18px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
      cursor: pointer;
    }
    //标题字体
    .title {
      height: 16px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      margin: 20px 0 12px 0;
      color: #333333;
      font-weight: bold;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        color: #4a94df;
      }
    }
    .titleTip {
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: -1px;
      color: #0f77f2;
    }
    .margintop {
      margin-top: 20px;
    }
  }
  .housingInfo-main-foot {
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        color: #4a94df;
      }
    }
  }
  .manager-danger-dialog {
    .el-dialog__header {
      border: none;
      padding: 14px 20px;
      .el-dialog__title {
        font-weight: 600;
      }
      .el-dialog__headerbtn {
        top: 14px;
      }
    }
    .el-dialog__body {
      padding: 20px 15px 30px 15px;
      .danger-info {
        color: #333333;
        font-size: 16px;
        margin-left: 40px;
        line-height: 38px;
        .item-info {
          padding-left: 40px;
        }
      }
    }
  }
}
</style>
